import { render, staticRenderFns } from "./VFileViewer.vue?vue&type=template&id=2735fa1b&"
import script from "./VFileViewer.vue?vue&type=script&lang=js&"
export * from "./VFileViewer.vue?vue&type=script&lang=js&"
import style0 from "./VFileViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports